const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    queryString: '',
    isFeatured: false,
};

const filterSlice = createSlice({
    name: "sortFilter",
    initialState,
    reducers: {
        featuredToggled: (state, action) => {
            state.isFeatured = action.payload;
        },
        queryStringChanged: (state, action) => {
            state.queryString = action.payload;
        }
    },
});

export default filterSlice.reducer;
export const { featuredToggled, queryStringChanged } = filterSlice.actions;
